import {
    ReactNode,
    FC,
    createContext,
    useState,
    useMemo,
    useEffect,
} from 'react';

interface RequestSearchItem {
    name: string;
    placeholder: React.ReactElement<any, any> | null;
    text: string;
    textar ?: string;
    lang: "ar"|"en";
    feedback ?: string;
    loading: boolean;
    showIcons: boolean;
    chart: any;
    stopConversation: boolean;
}
type ChatBotContextType = {
    tempRequestSearch?: RequestSearchItem[];
    setTempRequestSearch?: React.Dispatch<React.SetStateAction<RequestSearchItem[]>>;
    conversationId?:string;
    setConversationId?: React.Dispatch<React.SetStateAction<string>>;
};

const ChatBotContext = createContext<ChatBotContextType>({});

type ChatBotProps = {
    children: ReactNode;
};

const ChatBot: FC<ChatBotProps> = ({ children }) => {
    const [tempRequestSearch, setTempRequestSearch] = useState<RequestSearchItem[]>([
        {
          name: "Whiteshield",
          placeholder: null,
          loading: false,
          text: "Hello! I'm the AI Minister, a job market expert here to assist you with your inquiries. How can I help you today?",
          textar:"",
          lang:"en",
          showIcons: false,
          chart: null,
          stopConversation: false
        }]);
    const [conversationId, setConversationId] = useState<string>('');

    const ChatBotProviderValue = useMemo(
        () => ({ tempRequestSearch, setTempRequestSearch, conversationId, setConversationId }),
        [tempRequestSearch, setTempRequestSearch, conversationId, setConversationId],
    );

    useEffect(() => { }, []);

    return (
        <ChatBotContext.Provider value={ChatBotProviderValue}>
            {children}
        </ChatBotContext.Provider>
    );
};

export { ChatBot, ChatBotContext };
